import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { SectorsAirSummaryWithRuptureComponent } from './sectors-air-summary-with-rupture.component';
import { RuptureModule } from 'libraries/rupture/rupture.module';
import { SectorAirSummaryModule } from '../../../sectors/components/sectors-air/sector-air-summary/sector-air-summary.module';

@NgModule({
    imports: [
        CommonModule,
        RuptureModule,
        SectorAirSummaryModule,
    ],
    exports: [
        SectorsAirSummaryWithRuptureComponent,
    ],
    declarations: [
        SectorsAirSummaryWithRuptureComponent,
    ],
})
export class SectorsAirSummaryWithRuptureModule {}
